import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import OSGStatementsPage, { getDefaultUI } from "components/pages/OSGStatementsPage";

export default function CaptureOSGStatementsOpenDropdown(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
        .update([ "accountDD", "isActive" ], true)
        .submit();

    return <OSGStatementsPage ui={ ui } />
}